import React from "react";
import "../styles/NotFound.css";

const LostRouteUniverse = () => {
  return (
    <div className="lostroute-wrapper-x91">
      <div className="lostroute-box-x91">
        <h1 className="lostroute-title-x91">404</h1>

        <h2 className="lostroute-subtitle-x91">
          Oops! Page Not Found
        </h2>

        <p className="lostroute-text-x91">
          The page you are looking for does not exist or has been moved.
        </p>

        <a href="/" className="lostroute-btn-x91">
          Go Back Home
        </a>
      </div>
    </div>
  );
};

export default LostRouteUniverse;